import { type FC } from 'react';
import { Lock } from 'lucide-react';
import { Badge } from '@/components/ui/badge';
import type { Tramite } from '@/types';

interface BloqueadaBadgeProps {
  tramite: Pick<Tramite, 'bloqueado' | 'bloqueado_motivo'>;
  className?: string;
}

export const BloqueadaBadge: FC<BloqueadaBadgeProps> = ({ tramite, className }) => {
  if (!tramite.bloqueado) {
    return null;
  }

  return (
    <Badge
      variant="destructive"
      className={className}
      title={tramite.bloqueado_motivo || undefined}
    >
      <Lock className="h-3 w-3" />
      Bloqueada
    </Badge>
  );
};

export default BloqueadaBadge;
